export default __webpack_public_path__ + "static/media/dsv-pilot.9deca00a.svg";